import React from 'react';
import { useSelector } from 'react-redux';
import getConfigurationByKey from 'store/app/selector/getConfigurationByKey';
import OpPlusStoreCreditsStickyBar from '../op-ui-wrappers/OpPlusStoreCreditsStickyBar/OpPlusStoreCreditsStickyBar';
import OpPromoStickyBar from '../op-ui-wrappers/OpPromoStickyBar/OpPromoStickyBar';

const ENABLE_PROMO_STICKY_BAR = 'promoStickyBarEnabled';

interface OpStickyBarProps {
  variant?: 'landing-page' | 'product-page';
}
const OpStickyBar = ({ variant }: OpStickyBarProps) => {
  const promoStickyBarEnabled = useSelector(getConfigurationByKey(ENABLE_PROMO_STICKY_BAR));

  return promoStickyBarEnabled ? (
    <OpPromoStickyBar variant={variant} />
  ) : (
    <OpPlusStoreCreditsStickyBar variant={variant} />
  );
};

export default OpStickyBar;
